import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  reduxRallyNumber:'',
  reduxQuestionAnswered:false,
  reduxBestRally:'',
  reduxFlameOn:false
}

export const rallyTracker = createSlice({
  name: 'rallyTrack', //its not this that names the reducer for import in store. WTF?!
  initialState,
  reducers: {
    setRallyNumber: (state, action) => {
      state.reduxRallyNumber = action.payload
    },
    incrementRallyNumber: (state, action) => {
     state.reduxRallyNumber = state.reduxRallyNumber + 1
    },
    setQuestionAnswered:(state, action) =>{
     state.reduxQuestionAnswered = action.payload
    },
    setBestRally:(state, action) => {
     state.reduxBestRally = action.payload
    },
    setFlameOn:(state, action) => {
      state.reduxFlameOn = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
//export const { increment, decrement, incrementByAmount } = counterSlice.actions
export const { setRallyNumber,incrementRallyNumber,setQuestionAnswered,setBestRally,setFlameOn } = rallyTracker.actions
export default rallyTracker.reducer